 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"no-page-found-no-page-found-module":"no-page-found-no-page-found-module","pages-pages-module":"pages-pages-module","admin-accesscard-accesscard-module":"admin-accesscard-accesscard-module","admin-addstation-addstation-module":"admin-addstation-addstation-module","admin-roaming-roaming-module":"admin-roaming-roaming-module","admin-stations-commander-stations-commander-module":"admin-stations-commander-stations-commander-module","admin-topup-topup-module":"admin-topup-topup-module","admin-vendor-overview-vendor-overview-module":"admin-vendor-overview-vendor-overview-module","app-apptransactions-apptransactions-module":"app-apptransactions-apptransactions-module","app-payment-payment-module":"app-payment-payment-module","default~admin-live-live-sessions-module~admin-pos-overview-pos-overview-module~admin-userdashboard-u~6e43eb36":"default~admin-live-live-sessions-module~admin-pos-overview-pos-overview-module~admin-userdashboard-u~6e43eb36","admin-pos-overview-pos-overview-module":"admin-pos-overview-pos-overview-module","default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~pinvoice-minvoice-m~f6f52233":"default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~pinvoice-minvoice-m~f6f52233","default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~station-station-module":"default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~station-station-module","admin-live-live-sessions-module":"admin-live-live-sessions-module","admin-userdashboard-userdashboard-module":"admin-userdashboard-userdashboard-module","pinvoice-minvoice-module":"pinvoice-minvoice-module","default~admin-uptime-locationview-locationview-module~admin-uptime-uptime-module":"default~admin-uptime-locationview-locationview-module~admin-uptime-uptime-module","admin-uptime-locationview-locationview-module":"admin-uptime-locationview-locationview-module","default~admin-uptime-uptime-module~admin-uptime-vendorview-vendorview-module":"default~admin-uptime-uptime-module~admin-uptime-vendorview-vendorview-module","admin-uptime-vendorview-vendorview-module":"admin-uptime-vendorview-vendorview-module","admin-uptime-uptime-module":"admin-uptime-uptime-module","default~app-home-apphome-module~fleet-fleet-module~fleet-public-charging-public-charging-module~repo~b051a559":"default~app-home-apphome-module~fleet-fleet-module~fleet-public-charging-public-charging-module~repo~b051a559","app-home-apphome-module":"app-home-apphome-module","station-station-module":"station-station-module","fleet-fleet-module":"fleet-fleet-module","fleet-public-charging-public-charging-module":"fleet-public-charging-public-charging-module","reportsfleet-reportsfleet-module":"reportsfleet-reportsfleet-module","discounts-discounts-module":"discounts-discounts-module","events-events-module":"events-events-module","logs-logs-module":"logs-logs-module","rejected-authorizations-rejected-authorizations-module":"rejected-authorizations-rejected-authorizations-module","reports-reports-module":"reports-reports-module","ticket-ticket-module":"ticket-ticket-module","unauthorized-unauthorized-module":"unauthorized-unauthorized-module"}[chunkId]||chunkId) + "-es2015." + {"no-page-found-no-page-found-module":"4d449061680399cb314c","pages-pages-module":"0d33805600bdb52adfb4","admin-accesscard-accesscard-module":"7c8b144ec1f98914740f","admin-addstation-addstation-module":"9933f8ce1e300e729836","admin-roaming-roaming-module":"1af456219d89b56a45a6","admin-stations-commander-stations-commander-module":"69ae3f52bb1a21a1e606","admin-topup-topup-module":"56a065f798a3890b9592","admin-vendor-overview-vendor-overview-module":"b3ac1f5e9ac06ed2b976","app-apptransactions-apptransactions-module":"7741b55dec2498039977","app-payment-payment-module":"49984599275b963148d8","default~admin-live-live-sessions-module~admin-pos-overview-pos-overview-module~admin-userdashboard-u~6e43eb36":"168859c7979ce038994d","admin-pos-overview-pos-overview-module":"6d729e88f8a8d63aa047","default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~pinvoice-minvoice-m~f6f52233":"9a0581c9e2cda989ab67","default~admin-live-live-sessions-module~admin-userdashboard-userdashboard-module~station-station-module":"ba38ecdb4b4a60ba8536","admin-live-live-sessions-module":"f0780bfa5fb9b0aac660","admin-userdashboard-userdashboard-module":"c6bcc58b2a011f090504","pinvoice-minvoice-module":"2059218005c1c4aa23cf","default~admin-uptime-locationview-locationview-module~admin-uptime-uptime-module":"5baac4616d2adc01af04","admin-uptime-locationview-locationview-module":"9d9b54b214723c9281c8","default~admin-uptime-uptime-module~admin-uptime-vendorview-vendorview-module":"9babc87d81873c08a2d0","admin-uptime-vendorview-vendorview-module":"a0beb85822a2cf0a8214","admin-uptime-uptime-module":"1e177dec6faaa8347ef0","default~app-home-apphome-module~fleet-fleet-module~fleet-public-charging-public-charging-module~repo~b051a559":"91e70e8071e3ce697507","app-home-apphome-module":"f7e9aa5c7a89e0deda77","station-station-module":"0c629c054a19be362291","fleet-fleet-module":"f92048e80bdcdf0dd3dc","fleet-public-charging-public-charging-module":"4db61d89beea2b92ffa7","reportsfleet-reportsfleet-module":"c2b9e657c740b2939f6d","discounts-discounts-module":"dcd7c36f6700f7cf5f58","events-events-module":"7cccafb18c8dd0c3211a","logs-logs-module":"fff990458547740345fa","rejected-authorizations-rejected-authorizations-module":"53c5ba3bdd42f2ad22e5","reports-reports-module":"4576ca6ee80bb94f2ab9","ticket-ticket-module":"06fbdc4bdaf65efb891e","unauthorized-unauthorized-module":"f0e0be72af2905988437"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
